import { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { clearCustomerCancellations } from '../../../../appRedux/actions';
import {
  buttonLabel,
  cardConfig,
  formConfig,
  messages,
  recurrentCustomerUnbanMessage,
} from '../../../../constants';
import { useCustomModal } from '../../../../hooks/useCustomModal';

const { Paragraph } = Typography;

export const ClearCancellationsModalBody = ({ customer }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();
  const [response, setResponse] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);
    }
  }, [response, setShowModal]);

  const onSubmit = async (formValues) => {
    setIsLoading(true);

    setResponse(
      await dispatch(clearCustomerCancellations(customer.id, formValues.code))
    );

    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Paragraph>
        {recurrentCustomerUnbanMessage}
      </Paragraph>
      <Form autoComplete="off" onFinish={onSubmit} form={form} {...formConfig}>
        <Form.Item
          name="code"
          label="Código"
          rules={[
            {
              required: true,
              message: messages.required('Código'),
            },
          ]}
        >
          <Input placeholder="Ingresa el código" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          className="btn-form"
          loading={isLoading}
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
